import { Card } from "@/components/ui/card";

const STEPS = [
  { n: "01", t: "Browse tutors", d: "Open the Find Tutors page and filter by subject (French, English, Spanish, Math), level, hourly rate and availability." },
  { n: "02", t: "Pick someone great", d: "Open a profile to read their bio, teaching method, qualifications and typical availability." },
  { n: "03", t: "Send a session request", d: "Fill in your name, email, preferred date/time and learning goals. We'll email the tutor immediately." },
  { n: "04", t: "Confirm & learn live", d: "Your tutor replies to confirm or suggest a new time. Jump into a 1-on-1 live session when it's time." },
];

export default function HowItWorks() {
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
      <h1 className="text-4xl lg:text-5xl font-heading font-bold tracking-tight">How Tutors Paradise works</h1>
      <p className="mt-4 text-lg text-muted-foreground max-w-2xl">
        No signup required to request a session. Four steps between you and your next tutor.
      </p>

      <div className="mt-10 space-y-5">
        {STEPS.map((s) => (
          <Card key={s.n} className="p-7 flex gap-5">
            <span className="font-mono text-primary">{s.n}</span>
            <div>
              <h3 className="font-heading text-xl font-semibold">{s.t}</h3>
              <p className="mt-1 text-muted-foreground">{s.d}</p>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
